export const customOptions = {
    customSearch: (searchQuery, currentRow, columns) => {
    },
    onRowClick: (data) => null,
    filter: false,
}